import { PressControlComponent } from 'design/pressControl';
import React from 'react';

import { ReactComponent as GoogleLogoComponent } from 'svg/google-logo.svg';
import { useServices } from 'hooks/useServices';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

type Props = {
  redirectOnSucceedTo: string;
};

export const AuthorizeWithGoogleButton = (props: Props) => {
  const { redirectOnSucceedTo } = props;

  const { authorizeWithGoogleButton } = useIntlDictionary();

  const { authorizeWithProvider } = useServices();

  const authorizeWithGoogle = React.useCallback(() => {
    authorizeWithProvider({
      providerName: 'GOOGLE',
      redirectOnSucceedTo,
    });
  }, [authorizeWithProvider, redirectOnSucceedTo]);

  return (
    <PressControlComponent
      onPress={authorizeWithGoogle}
      theme="google"
      type="button"
      hasIcon
    >
      <GoogleLogoComponent />
      {authorizeWithGoogleButton}
    </PressControlComponent>
  );
};
